let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("e6NbN")).then(() => parcelRequire('1UNF9'));